<template>
  <section id="header-menu" class="header-container">
    <div class="header-content">
      <div class="header-grid-row">
        <router-link to="/" class="logo-container">
          <img
            class="site-logo"
            alt="Vue logo"
            src="@/assets/images/logo.png"
          />
          <h2 class="title">Michel Robert</h2>
        </router-link>
        <nav>

          <div class="menu-item button">
            <a
              href="https://www.linkedin.com/in/michel-robert-78b46057/"
              target="_blank"
            >
              Linkedin</a
            >
          </div>
        </nav>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeaderSection",
  props: {
    msg: String,
  },
  data: function () {
    return {
      menuOpen: false,
    };
  },
  methods: {
    toggleNav: function () {
      this.menuOpen = !this.menuOpen;
      this.$emit("toggle", this.menuOpen);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/components/_header.scss";
</style>
